export const NAVBAR_HEIGHT = 56;
export const SIDEBAR_WIDTH = 400;
export const BREADCRUMB_HEIGHT = 48;
